import { z } from 'zod';
/**
 * Two-step sign-in (uiv2 BE7, SET-09): an authenticator app's 6-digit code
 * (TOTP, RFC 6238) after the password, for the users who turn it on.
 */
export const TWO_STEP = {
    /** The name the authenticator app shows beside the account. */
    issuer: 'BakedShift',
    digits: 6,
    periodSeconds: 30,
    /** Codes one step either side of now are accepted — a phone clock a little off. */
    window: 1,
    recoveryCodeCount: 10,
    /** How long the password step's challenge stays usable. */
    challengeMinutes: 5,
};
/** A 6-digit code, or a recovery code (letters and digits, hyphens and spaces allowed). */
export const twoStepCodeSchema = z.object({ code: z.string().trim().min(6).max(24) });
export const twoStepLoginSchema = z.object({
    challenge: z.string().min(1).max(512),
    code: z.string().trim().min(6).max(24),
});
//# sourceMappingURL=two-step.js.map